module.exports = __webpack_public_path__ + "static/media/radionica.02ace73e.svg";